import React, { Suspense, lazy, useEffect, useMemo, useState } from "react";
import "./styles/BhpAdBannerWrapper.css";
import {
  AdvertisingDetailsType,
  AlertWithExecTypes,
  AlertWithoutExecTypes,
} from "../types/data_types";
import {
  callPhone,
  convertImgJsonToObj,
  fetchImgThumbnailData,
  getParamsFromSearchString,
  getPrintDateDDMMYYYY,
  getSeoUrl,
} from "../common/commonFunctions";
import {
  IonButton,
  IonFooter,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonTextarea,
  useIonToast,
} from "@ionic/react";
import {
  BhpMarketTypes,
  BhpThemeHeaderWithBack,
} from "../pages/BussinessHomePage";
import {
  API_SECURE_KEY,
  IDIGIZEN_BACKEND_URL,
  bhpEditLinks,
  downloadCouponForPromotion,
  getFileThumbnailDB,
  getPageType,
  userInfoRouter,
  whatsappMessage,
} from "../types/constants";
import ContentWithBackground from "../UI/ContentWithBackground";
import BhpAdBanner from "./BhpAdBanner";
import {
  arrowForwardOutline,
  arrowRedoOutline,
  book,
  call,
  close,
  downloadOutline,
  enterOutline,
  expandOutline,
  logoWhatsapp,
  pencil,
  share,
  trashBin,
} from "ionicons/icons";
import { getSessionDetails } from "../common/cookies";
// import AlertWithoutExec from "../UI/AlertWithoutExec";
import axios from "axios";
import {
  useModalController,
  useRecordUserInteractions,
  userActionsTable,
} from "../app/hooks";
import { useHistory, useLocation } from "react-router";
import LazyLoaderSpinner from "./LazyLoaderSpinner";
import Card from "../UI/Card";
import AlertWithExec from "../UI/AlertWithExec";

const ViewImage = lazy(() => import("../pages/ViewImage"));
const AlertWithoutExec = lazy(() => import("../UI/AlertWithoutExec"));

const BhpAdBannerWrapper: React.FC<{
  idx: number;
  businessId?: string;
  adData: AdvertisingDetailsType;
  logoImgData: string;
  marketDomain?: string;
  domainName: string;
  marketName?: string;
  editMode?: boolean;
  pageId?: string | number;
  marketType?: BhpMarketTypes;
  recordUserInteraction?: boolean;
  pageSection?: "MAIN" | "AD_ALL";
  enableSearchPop?: boolean;
  contextIsShop?: boolean;
}> = (props) => {
  const [imgData, setImgData] = useState("");
  const [imgCss, setImgCss] = useState("");
  // const [couponName, setCouponName] = useState<string>("");
  // const [couponPhone, setCouponPhone] = useState<string>("");
  const [downloadCoupon, setDownloadCoupon] = useState<{
    open: boolean;
    half?: boolean;
  }>({ open: false });
  const [openDownloadCoupon, closeDownloadCoupon] = useModalController(
    "ad-expand",
    setDownloadCoupon,
    () => {
      setDownloadCoupon({ open: false });
    }
  );
  // const [downloadingCoupon, setDownloadingCoupon] = useState(false);
  const [alert, setAlert] = useState<AlertWithoutExecTypes>({
    open: false,
    message: "",
  });
  const [alertExec, setAlertExec] = useState<AlertWithExecTypes>({
    open: false,
    executeFunc: undefined,
    funcInputs: {},
    message: "",
  });
  const recordAction = useRecordUserInteractions();

  // const [couponThankYou, setCouponThankYou] = useState<boolean>(false);
  // const [openCouponThankYou, closeCouponThankYou] = useModalController(
  //   "thanks",
  //   setCouponThankYou,
  //   () => {
  //     setCouponThankYou(false);
  //   }
  // );

  // const enterAnimation = (baseEl: HTMLElement) => {
  //   const root = baseEl.shadowRoot;

  //   const backdropAnimation = createAnimation()
  //     .addElement(root?.querySelector("ion-backdrop")!)
  //     .fromTo("opacity", "0.01", "var(--backdrop-opacity)");

  //   const wrapperAnimation = createAnimation()
  //     .addElement(root?.querySelector(".modal-wrapper")!)
  //     .keyframes([
  //       { offset: 0, opacity: "0", transform: "scale(0)" },
  //       { offset: 1, opacity: "0.99", transform: "scale(1)" },
  //     ]);

  //   return createAnimation()
  //     .addElement(baseEl)
  //     .easing("ease-out")
  //     .duration(250)
  //     .addAnimation([backdropAnimation, wrapperAnimation]);
  // };

  // const couponDownloadThankyouJsx = (
  //   <IonModal
  //     enterAnimation={enterAnimation}
  //     isOpen={!!couponThankYou}
  //     onDidDismiss={() => {
  //       // setCouponThankYou(-1);
  //       closeCouponThankYou();
  //     }}
  //     className="bhp-show-all-promo-modal"
  //   >
  //     <IonContent>
  //       <div className="bhp-download-coupon-thank-you-bg">
  //         <div className="bhp-download-coupon-thank-you-container">
  //           <div
  //             className="bhp-download-coupon-thank-you-container-inner"
  //             style={{
  //               fontSize: "2rem",
  //               fontWeight: "bold",
  //               color: "var(--ion-color-secondary)",
  //             }}
  //           >
  //             Congratulations!
  //           </div>
  //           <div
  //             className="bhp-download-coupon-thank-you-container-inner"
  //             style={{ margin: "3rem 0" }}
  //           >
  //             <div>Your Coupon From</div>
  //             <div style={{ fontSize: "2rem", fontWeight: "bold" }}>
  //               {props.adData?.shopName}
  //             </div>
  //             <div>is downloaded in your gallery!</div>
  //           </div>
  //           <div
  //             className="bhp-download-coupon-thank-you-container-inner"
  //             style={{ color: "var(--ion-color-dark)" }}
  //           >
  //             Please show this to the merchant to redeem!
  //             <div style={{ fontWeight: "bold" }}>
  //               Validity: {props.adData?.endDate}
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </IonContent>
  //     <IonFooter>
  //       <div style={{ padding: "5px", display: "flex" }}>
  //         <div
  //           style={{
  //             width:
  //               !props.marketDomain && !!props.adData?.shopDomain
  //                 ? "50%"
  //                 : "100%",
  //           }}
  //         >
  //           <IonButton
  //             expand="block"
  //             color={"secondary"}
  //             onClick={() => {
  //               // setCouponThankYou(-1);
  //               closeCouponThankYou();
  //             }}
  //           >
  //             <IonIcon icon={close} slot="start" />
  //             Dismiss
  //           </IonButton>
  //         </div>
  //         {!props.marketDomain && !!props.adData?.shopDomain && (
  //           <div style={{ width: "50%" }}>
  //             <IonButton
  //               expand="block"
  //               color={"primary"}
  //               onClick={() => {
  //                 window.location.assign(
  //                   `https://${props.domainName}.vypzee.com/business/${props.adData?.shopDomain}`
  //                 );
  //               }}
  //             >
  //               <IonIcon icon={arrowForwardOutline} slot="end" />
  //               Visit Store
  //             </IonButton>
  //           </div>
  //         )}
  //       </div>
  //     </IonFooter>
  //   </IonModal>
  // );

  const [openExpandImg, setOpenExpandImg] = useState<{
    open: boolean;
    fileName: string[];
    index: number;
  }>({ fileName: [""], index: 0, open: false });
  const [expandingImgOpen, expandingImgClose] = useModalController(
    "expndImg",
    setOpenExpandImg,
    () => {
      setOpenExpandImg({ fileName: [""], index: 0, open: false });
    }
  );

  /*************************************************************************
   * Name: triggerCouponDownload
   * Description: Function to trigger the coupon download for the current
   *              offer on display in the banner
   *************************************************************************/
  // const triggerCouponDownload = async () => {
  //   const { id, schoolId, token, email } = getSessionDetails();

  //   if (!couponName.trim()) {
  //     setAlert({
  //       message: "Please enter 'Name' to download coupon",
  //       open: true,
  //     });
  //     return;
  //   }
  //   if (couponName.trim().length < 3) {
  //     setAlert({ message: "'Name' entered is too short", open: true });
  //     return;
  //   }
  //   if (couponPhone.trim().length !== 10) {
  //     setAlert({
  //       message: "Please enter a valid phone to download coupon",
  //       open: true,
  //     });
  //     return;
  //   }

  //   setDownloadingCoupon(true);
  //   const res = await axios.get(
  //     `${IDIGIZEN_BACKEND_URL}/${downloadCouponForPromotion}`,
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       params: {
  //         Authorization: API_SECURE_KEY,
  //         token,
  //         email,
  //         userId: id,
  //         userName: couponName,
  //         userPhone: couponPhone,
  //         adId: props.adData?.id,
  //       },
  //       responseType: "arraybuffer",
  //     }
  //   );
  //   console.log("response type:: ", res.headers["content-type"]);
  //   if (res.headers["content-type"] === "application/json; charset=utf-8") {
  //     const uint8Array = new Uint8Array(res.data);
  //     const jsonObj = JSON.parse(String.fromCharCode.apply(null, uint8Array));
  //     console.log("response received =", res);
  //     setAlert({ message: jsonObj.data, open: true });
  //   } else {
  //     await promptFileDownload(res);
  //     const downloadCouponL = downloadCoupon;
  //     openCouponThankYou(true);
  //   }
  //   setDownloadCoupon(false);
  // };

  const [couponIdShown, setCouponIdShown] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const [present] = useIonToast();

  useEffect(() => {
    const params = getParamsFromSearchString(location.search);
    if (params.couponId && props.adData && !couponIdShown) {
      // const couponId = parseInt(params.couponId);
      // if (params.couponId == props.adData.id) setDownloadCoupon(true);
      if (params.couponId && params.couponId == props.adData.id) {
        if (props.recordUserInteraction) {
          recordAction({
            action: userActionsTable.adScan,
            pageId: props.pageId,
            pageSection: props.pageSection,
            pageType: getPageType(!!props.marketType, props.marketType),
            popId: props.adData.id,
            popType: "AD",
          });
        }
        openDownloadCoupon({
          open: true,
        });
      }
      setCouponIdShown(true);
    }
  }, [location, props.adData]);

  const bgImg: { url?: string; fileName: string } = useMemo(() => {
    if (props.adData?.bgImg?.imgName) {
      const imgObj = convertImgJsonToObj(props.adData.bgImg?.imgName);
      const url = `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${
        imgObj.fileName
      }&
                percentage=${100}&Authorization=${API_SECURE_KEY}&isMobile=${true}`;
      return { fileName: imgObj.fileName, url: url };
    } else {
      return { fileName: "", url: "" };
    }
  }, [props.adData]);

  const storeCtaJsx = (
    <Card title={props.adData?.shopName}>
      {!!props.adData.shopAddress && (
        <div style={{ fontSize: "0.9rem", padding: "10px 0" }}>
          {props.adData?.shopAddress?.split("\n").map((el, idx) => {
            return <span key={idx}>{el}, </span>;
          })}
        </div>
      )}
      <div
        style={{
          display: "flex",
          padding: "5px",
        }}
      >
        <div style={{ width: "50%" }}>
          <IonButton
            fill="clear"
            expand="block"
            color={"tertiary"}
            class={`{coupon-download-phone-${props.adData?.shopPhone}`}
            onClick={() => {
              if (props.recordUserInteraction) {
                recordAction({
                  action: userActionsTable.call,
                  pageId: props.pageId,
                  pageSection: props.pageSection,
                  pageType: getPageType(!!props.marketType, props.marketType),
                  popId: props.adData.id,
                  popType: "AD",
                });
              }
              // setDownloadCoupon(false);
              callPhone(props.adData?.shopPhone);
            }}
          >
            <IonIcon icon={call} slot="start" />
            Call
          </IonButton>
        </div>
        <div style={{ width: "50%" }}>
          <IonButton
            fill="clear"
            expand="block"
            class={`{coupon-download-whatsapp-${props.adData?.shopPhone}`}
            onClick={() => {
              if (props.recordUserInteraction) {
                recordAction({
                  action: userActionsTable.whatsapp,
                  pageId: props.pageId,
                  pageSection: props.pageSection,
                  pageType: getPageType(!!props.marketType, props.marketType),
                  popId: props.adData.id,
                  popType: "AD",
                });
              }
              whatsappMessage(
                `Hello ${props.adData?.shopName}, I found offer "${props.adData?.title}" on VypZee.com`,
                props.adData?.shopPhone
              );
            }}
          >
            <IonIcon icon={logoWhatsapp} slot="start" />
            Message
          </IonButton>
        </div>
      </div>
      {!props.contextIsShop && (
        <IonButton
          expand="block"
          color={"secondary"}
          fill="solid"
          size="small"
          onClick={() => {
            // window.location.assign(
            //   `https://${props.domainName}.vypzee.com/business/${props.adData?.shopDomain}`
            // );
            // console.log("SEO detail ", props.adData.seoUrlDetails);
            if (props.recordUserInteraction) {
              recordAction({
                action:
                  props?.adData?.orderMode === "booking"
                    ? userActionsTable.bookATable
                    : userActionsTable.visitPage,
                pageId: props.pageId,
                pageSection: props.pageSection,
                pageType: getPageType(!!props.marketType, props.marketType),
                popId: props.adData.id,
                popType: "AD",
              });
            }
            const args =
              props?.adData?.orderMode === "booking"
                ? `?tableBooking=true&bookingCouponId=${props.adData.id}`
                : "";
            if (
              !props?.adData?.seoUrlDetails?.cityUrl ||
              !props?.adData?.seoUrlDetails?.stateUrl
            ) {
              //re-direct if it is a fully qualified URL
              const isDomainFQDN = (shopDomain: string): boolean => {
                try {
                  new URL(props.adData?.shopDomain);
                  return true;
                } catch {
                  return false;
                }
              };
              if (isDomainFQDN(props.adData?.shopDomain)) {
                window.location.assign(props.adData?.shopDomain);
              } else {
                window.location.assign(
                  `https://${props.domainName}.vypzee.com/business/${props.adData?.shopDomain}${args}`
                );
              }
            } else {
              window.location.assign(
                getSeoUrl(props?.adData?.seoUrlDetails, false, args)
              );
            }
          }}
        >
          <IonIcon
            icon={props?.adData?.orderMode === "booking" ? book : enterOutline}
            slot="start"
          />
          {props?.adData?.orderMode === "booking"
            ? "Book A Table"
            : "Open Store Page"}
        </IonButton>
      )}
    </Card>
  );

  const couponDownloadJsx = (
    <IonModal
      isOpen={!!downloadCoupon.open}
      onDidDismiss={() => {
        // setDownloadCoupon(false);
        closeDownloadCoupon();
        // setDownloadingCoupon(false);
      }}
      initialBreakpoint={downloadCoupon?.half ? 0.6 : 1}
      breakpoints={[0.6, 1]}
    >
      <BhpThemeHeaderWithBack
        onBack={() => {
          // setDownloadCoupon(false);
          closeDownloadCoupon();
        }}
        title={"Offer Details"}
        button={{
          name: "Share Link",
          exec: () => {
            let url = "";
            if (!props.marketDomain) {
              url = `https://${props.domainName}.vypzee.com?couponId=${props.adData?.id}`;
            } else {
              url = `https://${props.marketDomain}.vypzee.com/business/${props.domainName}?couponId=${props.adData?.id}`;
            }
            const message = `Offer "${props.adData?.title}" running at ${
              props.adData?.shopName
            }, ${
              props.marketName ? props.marketName : ""
            }: \nCheck it out at: ${url}`;

            if (props.recordUserInteraction) {
              recordAction({
                action: userActionsTable.share,
                pageId: props.pageId,
                pageSection: props.pageSection,
                pageType: getPageType(!!props.marketType, props.marketType),
                popId: props.adData.id,
                popType: "AD",
              });
            }
            // window.open(`https://wa.me/?text=${message}`, "_system");
            whatsappMessage(message);
          },
        }}
      />
      <ContentWithBackground>
        {/* <div
          style={{
            margin: "10px 0",
            display: "flex",
            justifyContent: "center",
            height: "100%",
            alignItems: "center",
          }}
        >
          {!!downloadCoupon && (
            <BhpAdBanner
              adData={props.adData}
              idx={props.idx}
              logoImgData={props.logoImgData}
            />
          )}
        </div> */}
        {/* <div style={{ padding: "10px" }}>
          <div
            style={{
              padding: "10px",
              background: "var(--ion-color-bhp-hdr-dark)",
              color: "var(--ion-color-light)",
              borderRadius: "10px",
            }}
          >
            Please show this to the cashier to avail offer
          </div>
        </div> */}
        {storeCtaJsx}
        <Card title="Offer Details">
          {!!bgImg.url && (
            <div
              style={{
                height: "200px",
                width: "100%",
                background: "white",
                borderBottom: "1px solid lightgray",
                position: "relative",
              }}
              onClick={() => {
                expandingImgOpen({
                  fileName: [bgImg.fileName],
                  index: 0,
                  open: true,
                });
              }}
            >
              <div
                style={{
                  height: "30px",
                  width: "30px",
                  background: "rgba(0,0,0,0.4)",
                  position: "absolute",
                  zIndex: "10",
                  top: 10,
                  right: 10,
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <IonIcon icon={expandOutline} />
              </div>
              <img
                src={bgImg.url}
                style={{ objectFit: "contain", height: "100%", width: "100%" }}
                alt={props.adData.title}
                loading="lazy"
              />
            </div>
          )}
          <IonItem>
            <IonLabel position="stacked" color={"tertiary"}>
              Details
            </IonLabel>
            <IonTextarea
              autoGrow={true}
              readonly={true}
              value={`${props.adData.title}${
                props.adData.subTitle ? ` - ${props.adData.subTitle}` : ""
              }`}
            />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked" color={"tertiary"}>
              Last Date
            </IonLabel>
            <IonTextarea
              autoGrow={true}
              readonly={true}
              value={getPrintDateDDMMYYYY(props.adData.endDate)}
            />
          </IonItem>
        </Card>
        {/* <IonFooter> */}
        <div>
          {/* <IonButton
            fill="clear"
            color="dark"
            expand={"full"}
            onClick={() => {
              let url = "";
              if (!props.marketDomain) {
                url = `https://${props.domainName}.vypzee.com?couponId=${props.adData?.id}`;
              } else {
                url = `https://${props.marketDomain}.vypzee.com/business/${props.domainName}?couponId=${props.adData?.id}`;
              }
              const message = `Offer "${props.adData?.title}" running at ${
                props.adData?.shopName
              }, ${
                props.marketName ? props.marketName : ""
              }: \nCheck it out at: ${url}`;

              // window.open(`https://wa.me/?text=${message}`, "_system");
              whatsappMessage(message);
            }}
          >
            <IonIcon icon={arrowRedoOutline} slot="start" />
            Share Offer Link
          </IonButton> */}
        </div>
        {/* <div className="bhp-download-coupon-footer"> */}
        {/* <div>{props.adData?.shopName}</div> */}
        {/* {!props.marketDomain && (
            <div
              style={{
                background: "var(--ion-color-light)",
                color: "black",
                fontWeight: "normal",
                padding: "5px",
                borderRadius: "5px",
                fontSize: "0.7rem",
              }}
              onClick={() => {
                window.location.assign(
                  `https://${props.domainName}.vypzee.com/business/${props.adData?.shopDomain}`
                );
              }}
            >
              Visit Store
            </div>
          )} */}
        {/* </div> */}
        {/* <div style={{ display: "flex", padding: "5px" }}>
          <div style={{ width: "50%" }}>
            <IonItem>
              <IonLabel position="stacked" color={"tertiary"}>
                Name
              </IonLabel>
              <IonInput
                value={couponName}
                onIonChange={(e) => {
                  setCouponName(e.detail.value);
                }}
              />
            </IonItem>
          </div>
          <div style={{ width: "50%" }}>
            <IonItem>
              <IonLabel position="stacked" color={"tertiary"}>
                Phone (10 digit)
              </IonLabel>
              <IonInput
                type="number"
                value={couponPhone}
                onIonChange={(e) => {
                  setCouponPhone(e.detail.value);
                }}
              />
            </IonItem>
          </div>
        </div> */}
        {/* <div style={{ display: "flex", padding: "5px" }}>
          <div style={{ width: "50%" }}>
            <IonButton
              expand="block"
              color={"tertiary"}
              class={`{coupon-download-phone-${props.adData?.shopPhone}`}
              onClick={() => {
                // setDownloadCoupon(false);
                callPhone(props.adData?.shopPhone);
              }}
            >
              <IonIcon icon={call} slot="start" /> Call
            </IonButton>
          </div>
          <div style={{ width: "50%" }}>
            <IonButton
              expand="block"
              class={`{coupon-download-whatsapp-${props.adData?.shopPhone}`}
              onClick={() => {
                whatsappMessage(
                  `Hello ${props.adData?.shopName}, I found offer: ${props.adData?.title} on VypZee.com`,
                  props.adData?.shopPhone
                );
              }}
            >
              <IonIcon icon={logoWhatsapp} slot="start" /> Message
            </IonButton>
          </div>
        </div> */}
        {/* <div style={{ padding: "5px", paddingTop: 0 }}>
          <IonButton
            expand="block"
            color={"secondary"}
            fill="clear"
            onClick={() => {
              window.location.assign(
                `https://${props.domainName}.vypzee.com/business/${props.adData?.shopDomain}`
              );
            }}
          >
            <IonIcon icon={enterOutline} slot="start" /> Visit Store
          </IonButton>
        </div> */}
        {/* </IonFooter> */}
      </ContentWithBackground>
      {!!props?.editMode && (
        <IonFooter>
          <IonButton
            fill="solid"
            color={"tertiary"}
            expand="block"
            onClick={() => {
              //validate that the user is allowed to edit
              let { schoolId, role } = getSessionDetails();
              if (
                role === "IDIGIZENSUPERADMIN" ||
                role === "MARKETSUPERADMIN" ||
                schoolId == props.businessId
              ) {
                history.push(
                  bhpEditLinks.editOffer
                    .replace("%offerId%", `${props.adData.id}`)
                    .replace("%SCHOOL_ID%", `${props.pageId}`)
                );
              } else {
                console.log(
                  `schoolId = ${schoolId}, businessId = ${props.businessId}`
                );
                present({
                  message: "You can only edit your own Gives/Asks",
                  position: "middle",
                  duration: 1500,
                });
              }
            }}
          >
            <IonIcon icon={pencil} />
          </IonButton>
        </IonFooter>
      )}
    </IonModal>
  );

  useEffect(() => {
    const getImg = async () => {
      try {
        //console.log("image name ", props.adData);
        const imgObj = convertImgJsonToObj(props.adData.bgImg?.imgName);
        setImgCss(imgObj.imgCss);

        const imgData = await fetchImgThumbnailData(imgObj.fileName);
        setImgData(imgData);
      } catch (e) {
        console.log(e);
      }
    };
    if (
      !!props.adData.bgImg?.imgName &&
      typeof props.adData.bgImg?.imgName === "string"
    ) {
      getImg();
    } else if (props.logoImgData) {
      setImgData(props.logoImgData);
    }
  }, [props.adData, props.logoImgData]);

  return (
    <>
      {couponDownloadJsx}
      <AlertWithExec openAlert={alertExec} setOpenAlert={setAlertExec} />
      {/* {couponDownloadThankyouJsx} */}
      <Suspense fallback={<LazyLoaderSpinner />}>
        {alert.open && (
          <AlertWithoutExec openAlert={alert} setOpenAlert={setAlert} />
        )}
        {openExpandImg.open && (
          <ViewImage
            modalControls={openExpandImg}
            onDismissModal={() => {
              expandingImgClose();
            }}
          />
        )}
      </Suspense>
      <BhpAdBanner
        contextIsShop={props.contextIsShop}
        adData={props.adData}
        idx={props.idx}
        logoImgData={props.logoImgData}
        onClick={() => {
          if (props.recordUserInteraction) {
            recordAction({
              action: userActionsTable.expandDetails,
              pageId: props.pageId,
              pageSection: props.pageSection,
              pageType: getPageType(!!props.marketType, props.marketType),
              popId: props.adData.id,
              popType: "AD",
            });
          }
          // if (props.contextIsShop) {
          //   setAlertExec({
          //     executeFunc: (inp) => {
          //       openDownloadCoupon({ open: true });
          //     },
          //     funcInputs: {},
          //     message: "Please show this to the cashier to avail offer",
          //     open: true,
          //     header: "Avail Offer",
          //     primaryButtonName: "Offer Details",
          //     cancelButtonName: "Ok",
          //   });
          // } else {
          openDownloadCoupon({ open: true });
          // }
        }}
      />
    </>
  );
};

export default BhpAdBannerWrapper;
